import styles from './index.module.less';
import { FC } from 'react';
import cn from 'classnames';
import { activityTypes, ICartActivityTip } from '@base/cart/interface';
import Iconfont from '@base/lib/Iconfont';
import Link from '@base/lib/ThemeLink';
import { CartType } from '@base/cart/useCart';
import { AppleWatchHelp } from '@base/cart/CartActivityTips/AppleWatchHelp';
import HelpPopup from '@base/lib/HelpPopup';
import BonusItemListPc from '@base/cart/BonusItemListPc';
import BonusItemListM from '@base/cart/BonusItemListM';
import { isPhone } from 'base/utils/client';
import { useTrans } from 'base/utils/i18n';

export type IActivityTipProps = ICartActivityTip & {
    type?: 'simple' | 'whole';
    cart: CartType;
    bonusListType?: 'm' | 'pc'
}

const icons: Record<typeof activityTypes[number], string> = {
    bfAppleWatch: 'icon-gift',
    freeShipping: 'icon-shipped',
    bundleDeals: 'icon-bonus',
    bonusItem: 'icon-bonus',
};

export const ActivityTip: FC<IActivityTipProps> = props => {
    const { t } = useTrans();
    const {
        type = 'simple',
        activityLink,
        activityType,
        status,
        cart,
        bonusListType = 'pc'
    } = props;


    const icon = icons[activityType];
    if (!icon) {
        return null;
    }

    const satisfied = status === 1;
    let { title, tip, } = props;
    const isAppleWatch = activityType === 'bfAppleWatch';
    if (isAppleWatch) {
        title = t('web_cart_black_friday_title');
        tip = t('web_cart_black_friday_tip');
    }

    const statusIcon = (
        <div className={cn('status-icon', { 'status-icon-whole': type === 'whole' })}>
            <Iconfont className={satisfied && !isAppleWatch ? 'icon-select' : icon}/>
        </div>
    );

    const text = (
        <div className="text">
            {type === 'whole' && <div className="title">{title}</div>}
            <div className="tip" dangerouslySetInnerHTML={{ __html: tip }}/>
        </div>
    );

    const arrow = (
        <div className="arrow text-right">
            <Iconfont className="icon-arrow-right"/>
        </div>
    );

    return isAppleWatch
        ? (
            <div className={cn(
                'activity-tip',
                styles['activity-tip'],
                styles['bf-apple-watch']
            )}>
                <HelpPopup
                    trigger={
                        <div className="link">
                            {statusIcon}
                            {text}
                            {arrow}
                        </div>
                    }
                    title={t('web_cart_black_friday_title')}
                    contentSize={'large'}
                    content={<AppleWatchHelp/>}
                />
            </div>
        )
        : (
            <div className={cn(
                'activity-tip',
                styles['activity-tip'],
                satisfied ? styles.satisfied : styles.unsatisfied
            )}>
                {satisfied || !activityLink ? (
                    <div className="link">
                        {statusIcon}
                        {text}
                    </div>
                ) : (
                    <Link href={activityLink}>
                        <a className="link">
                            {statusIcon}
                            {text}
                            {arrow}
                        </a>
                    </Link>
                )}

                {cart.showBonusProdList && activityType === 'bonusItem' && (
                    <>{isPhone || bonusListType == 'm' ? (
                        <BonusItemListM cart={cart}/>

                    ) : (
                        <BonusItemListPc cart={cart}/>

                    )}</>
                )}
            </div>
        );
};
